import type { EditionPeriodiqueOptionType } from '@/types';

export const ETATS_RECAPITULATIFS_OPTIONS: readonly EditionPeriodiqueOptionType[] = [
  {
    key: 'recapitulatif_periodique_mr',
    label: 'Récapitulatif des encaissements par mode de règlement',
  },
  {
    key: 'recapitulatif_periodique_produit',
    label: 'Récapitulatif des encaissements par produit',
  },
  {
    key: 'recapitulatif_periodique_produit_mr',
    label: 'Récapitulatif des encaissements par produit et mode de règlement',
  },
  {
    key: 'recapitulatif_periodique_journalier_produit_mr',
    label: 'Récapitulatif journalier des encaissements par produit et mode de règlement',
  },
  {
    key: 'recapitulatif_periodique_budget_produit_imputation',
    label: 'Récapitulatif des encaissements par budget / produit / imputations',
  },
];
